import React, { useState } from "react";

const labels = {
  all: {
    da: "Alle",
    en: "All",
    de: "Alles",
  },
};

/*
 * This component displays a selector for settings in the best spots sidebar (used for coast type and fish type)
 */

const SettingsSelector = (props) => {
  const [value, setValue] = useState(labels.all[props.language]);

  const handleChange = (e) => {
    setValue(e.target.value);
    props.onChange(e.target.value);
  };

  const options = props.options.map((o, i) => (
    <option key={i} value={o}>
      {o}
    </option>
  ));

  return (
    <div className="settingsCard" style={enabledStyle}>
      <div className="card-body">
        <h5 className="toggleTextLeft">{props.text}</h5>
        <h4 className="toggleTextRight">{props.selected}</h4>
        <select
          value={value}
          className="settingSelector"
          onChange={handleChange}
        >
          {options}
        </select>
      </div>
    </div>
  );
};

const enabledStyle = {
  background: "#0000004d",
  opacity: "1",
};

export default SettingsSelector;
